import React, { Component } from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
// import { Flag, Form, Button, Grid } from 'semantic-ui-react';
import { Form, Grid } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { has, pick } from 'lodash';
import styled from 'styled-components';
// import COUNTRY_CODES from './CountryCodes';


import {
  // HHMultipleSelect,
  HHCheckbox
  // HHInput,
  // HHSingleSelect
} from './fields';
import { FORM_NAME } from '../forms/formConstant';
import { fetchTags, userLogout } from '../actions';
import { phoneNumberRegex } from './regex';
import { FormPhoneInputField } from '../../uiStandard/event/formPhoneInput';
import { MultipleSelect } from '../../uiStandard/event/multipleSelect';
import { Dropdown } from '../../uiStandard/event/dropdown';
import { Input } from '../../uiStandard/event/input';
import { FormSubmitButton } from '../../uiStandard/event/formInput';

// class DialCodeOptionComponent extends Component {
//   render() {
//     return (
//       <div
//         className={this.props.className}
//         onMouseDown={event => {
//           event.preventDefault();
//           event.stopPropagation();
//           this.props.onSelect(this.props.option, event);
//         }}
//         onMouseEnter={event => {
//           this.props.onFocus(this.props.option, event);
//         }}
//         onMouseMove={event => {
//           if (this.props.isFocused) return;
//           this.props.onFocus(this.props.option, event);
//         }}
//         title={this.props.option.title}
//       >
//         <Flag name={this.props.option.countryCode} /> {this.props.children}
//       </div>
//     );
//   }
// }

// const DialCodeValueComponent = props => (
//   <div className='Select-value' title={props.value.title}>
//     <span className='Select-value-label'>
//       <Flag name={props.value.countryCode} /> {props.children}
//     </span>
//   </div>
// );

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) =>
    Yup.object().shape({
      name: Yup.string().required(translate('form.error.mixed.required')),
      countryCode: Yup.string(),
      countryDialCode: Yup.string().nullable(),
      phone: Yup.string().matches(
        phoneNumberRegex,
        translate('form.error.regex.phoneNumber')
      ),
      email: Yup.string().email(translate('form.error.string.email')),
      location: Yup.string(),
      bio: Yup.string(),
      tags: Yup.array()
        .min(1, translate('form.error.array.min'))
        .max(5, translate('form.error.array.max'))
        .of(
          Yup.object().shape({
            label: Yup.string().required(),
            value: Yup.string().required()
          })
        ),
      education: Yup.string().required(translate('form.error.mixed.required')),
      profession: Yup.string().required(translate('form.error.mixed.required')),
      isJobSeeking: Yup.boolean()
    }),
  mapPropsToValues: props => props.initialValues,
  handleSubmit: (values, { props }) => {
    const submittedValues = {
      ...values,
      tags: values.tags.map(t => t.value),
      education: values.education.value,
      profession: values.profession.value
    };

    props.handleSubmit(submittedValues);
  },
  displayName: FORM_NAME.LOGIN_FORM
});

// eslint-disable-next-line
class ProfileForm extends Component {
  // state = { countryDialCodeOptions: [] };

  componentWillMount() {
    // const countryDialCodeOptions = map(COUNTRY_CODES, pcc => ({
    //   value: pcc.dial_code,
    //   countryCode: pcc.code,
    //   label: `(+${pcc.dial_code}) ${pcc.name}`
    // }));

    // this.setState({ countryDialCodeOptions });

    const { tagOptions } = this.props;
    if (!tagOptions.length) {
      this.props.fetchTags();
    }
  }

  render() {
    const {
      tagOptions,
      handleSubmit,
      isSubmitting,
      translate
      // values,
    } = this.props;

    // const educationOptions = [
    //   { value: 'High School', label: translate('form.label.highSchool') },
    //   { value: 'Diploma', label: translate('form.label.diploma') },
    //   { value: 'College', label: translate('form.label.college') },
    //   { value: 'University', label: translate('form.label.university') },
    //   { value: 'Master', label: translate('form.label.master') },
    //   { value: 'PhD', label: translate('form.label.PhD') },
    //   { value: 'Others', label: translate('common.others') }
    // ];

    const educationOptions = [
      { value: 'High School', content: translate('form.label.highSchool') },
      { value: 'Diploma', content: translate('form.label.diploma') },
      { value: 'College', content: translate('form.label.college') },
      { value: 'University', content: translate('form.label.university') },
      { value: 'Master', content: translate('form.label.master') },
      { value: 'PhD', content: translate('form.label.PhD') },
      { value: 'Others', content: translate('common.others') }
    ];

    // const professionOptions = [
    //   { value: 'Designer', label: translate('form.label.designer') },
    //   { value: 'Software Engineer', label: translate('form.label.softwareEngineer') },
    //   { value: 'Data Analysis', label: translate('form.label.dataAnalysis') },
    //   { value: 'AI', label: translate('form.label.AI') },
    //   { value: 'Businsess', label: translate('form.label.businsess') },
    //   { value: 'Human Resource', label: translate('form.label.humanResource') },
    //   { value: 'Finance', label: translate('form.label.finance') },
    //   { value: 'Marketing', label: translate('form.label.marketing') },
    //   { value: 'Health', label: translate('form.label.health') },
    //   { value: 'Others', label: translate('common.others') }
    // ];
    const professionOptions = [
      { value: 'Designer', content: translate('form.label.designer') },
      { value: 'Software Engineer', content: translate('form.label.softwareEngineer') },
      { value: 'Data Analysis', content: translate('form.label.dataAnalysis') },
      { value: 'AI', content: translate('form.label.AI') },
      { value: 'Businsess', content: translate('form.label.businsess') },
      { value: 'Human Resource', content: translate('form.label.humanResource') },
      { value: 'Finance', content: translate('form.label.finance') },
      { value: 'Marketing', content: translate('form.label.marketing') },
      { value: 'Health', content: translate('form.label.health') },
      { value: 'Others', content: translate('common.others') }
    ];

    // const { countryDialCodeOptions } = this.state;

    return (
      <Form className='profileForm'>
        <Form.Field>
          {/* <label htmlFor='name'>{translate('form.label.name')}</label> */}
          <Field
            name='name'
            // component={HHInput}
            component={Input}
            otherProps={{
              id: 'name',
              type: 'text',
              focus: true,
              placeholder: translate('form.placeholder.name'),
              label: translate('form.label.name')
            }}
          />
        </Form.Field>
        <Form.Field>
          {/* <label htmlFor='phone'>{translate('form.label.phoneNumber')}</label> */}
          <Grid doubling columns={2}>
            {/* <Grid.Column width={6}>
              <Field
                name='countryDialCode'
                component={HHSingleSelect}
                otherProps={{
                  disabled: this.props.isPhoneVerified,
                  simpleValue: true,
                  clearable: true,
                  searchable: true,
                  options: countryDialCodeOptions,
                  placeholder: translate('form.placeholder.dialCode'),
                  optionComponent: DialCodeOptionComponent,
                  valueComponent: DialCodeValueComponent
                }}
              />
            </Grid.Column> */}
            <Grid.Column width={10}>
              <Field
                name='phone'
                // component={HHInput}
                component={FormPhoneInputField}
                otherProps={{
                  disabled: this.props.isPhoneVerified,
                  type: 'text',
                  id: 'phone',
                  // icon: 'phone',
                  // iconPosition: 'left',
                  maxLength: 11,
                  placeholder: translate('form.placeholder.phoneNumber'),
                  label: translate('form.label.phoneNumber')
                }}
              />
            </Grid.Column>
          </Grid>
        </Form.Field>
        <Form.Field disabled>
          {/* <label htmlFor='email'>{translate('form.label.email')}</label> */}
          <Field
            name='email'
            // component={HHInput}
            component={Input}
            otherProps={{
              id: 'email',
              type: 'email',
              // icon: 'mail',
              disabled: true,
              label: translate('form.label.email')
              // iconPosition: 'left'
            }}
          />
        </Form.Field>
        <Form.Field>
          {/* <label htmlFor='location'>{translate('form.label.city')}</label> */}
          <Field
            name='location'
            // component={HHInput}
            component={Input}
            otherProps={{
              id: 'location',
              type: 'text',
              // icon: 'marker',
              // iconPosition: 'left',
              placeholder: translate('form.placeholder.city'),
              label: translate('form.label.city')
            }}
          />
        </Form.Field>
        <Form.Field>
          {/* <label htmlFor='bio'>{translate('form.label.bio')}</label> */}
          <Field
            name='bio'
            // component={HHInput}
            component={Input}
            otherProps={{
              id: 'bio',
              type: 'text',
              focus: true,
              placeholder: translate('form.placeholder.bio'),
              label: translate('form.label.bio')
            }}
          />
        </Form.Field>
        <Form.Field>
          {/* <label htmlFor='education'>{translate('yourEducation')}</label> */}
          <Field
            name='education'
            // component={HHSingleSelect}
            component={Dropdown}
            otherProps={{
              id: 'education',
              // options: educationOptions,
              listItems: educationOptions,
              // creatable: false,
              placeholder: translate('button.select'),
              label: translate('yourEducation')
            }}
          />
        </Form.Field>

        <Form.Field>
          {/* <label htmlFor='profession'>{translate('yourProfession')}</label> */}
          <Field
            name='profession'
            // component={HHSingleSelect}
            component={Dropdown}
            otherProps={{
              id: 'profession',
              // options: professionOptions,
              listItems: professionOptions,
              // creatable: false,
              placeholder: translate('button.select'),
              label: translate('yourProfession')
            }}
          />
        </Form.Field>
        <Form.Field>
          <label htmlFor='tags'>
            {translate('form.label.tags.topSkills', { num: 5 })}
          </label>
          <Field
            name='tags'
            // component={HHMultipleSelect}
            component={MultipleSelect}
            otherProps={{
              id: 'tags',
              options: tagOptions,
              creatable: true,
              placeholder: translate('form.placeholder.tags.topSkills')
            }}
          />
        </Form.Field>
        <Form.Field>
          <Field
            name='isJobSeeking'
            component={HHCheckbox}
            otherProps={{
              label: translate('LookingForJob'),
              toggle: true,
              id: 'isJobSeeking',
              className: 'inline'
            }}
          />
        </Form.Field>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {/* <Button
            primary
            onClick={handleSubmit}
            content={translate('update')}
            disabled={isSubmitting}
            loading={isSubmitting}
            size='large'
            className='g-rounded'
          /> */}
          <RegularButton
            onClick={handleSubmit} label={translate('update')} disabled={isSubmitting}
            isSubmitting={isSubmitting} type='button'
          />
        </div>
      </Form>
    );
  }
}

const RegularButton = styled(FormSubmitButton)`
&&&&& {
  min-height: 41.13px;
  width: 338px;
  @media (max-width: 768px) {
    width: 100%;
  }
}
`;

export default compose(
  withLocalize,
  connect(
    ({ user, tags }) => {
      let initialValues = {
        name: '',
        // countryCode: '',
        // countryDialCode: '',
        phone: '',
        email: '',
        location: '',
        bio: '',
        education: '',
        profession: '',
        tags: [],
        isJobSeeking: ''
      };

      let isPhoneVerified = false;

      if (has(user, 'profile.basicInfo')) {
        // eslint-disable-next-line
        isPhoneVerified = user.profile.basicInfo.isPhoneVerified;
        initialValues = pick(user.profile.basicInfo, [
          'name',
          // 'countryCode',
          // 'countryDialCode',
          'phone',
          'email',
          'location',
          'bio',
          'tags',
          'education',
          'profession',
          'isJobSeeking'
        ]);
      }

      initialValues.tags = initialValues.tags.map(t => ({
        label: t,
        value: t
      }));

      return {
        tagOptions: tags.tagOptions || [],
        initialValues,
        isPhoneVerified,
        user
      };
    },
    { fetchTags, userLogout }
  ),
  formikEnhancer
)(ProfileForm);



// WEBPACK FOOTER //
// ./src/components/forms/profileForm.js